import { useEffect, useState } from "react";
import React from 'react';
import { useNavigate, Link } from "react-router-dom";
import { getCircular } from "../Service/Api";
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Circular = () => {
  
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(); 
    const [yearRanges, setYearRanges] = useState([]);  

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        setSelectedYear(currentYear.toString());
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const galleryData1 = await getCircular();
            const galleryData = galleryData1.filter(item => item.category === 'Circular')
        console.log(galleryData)
            setData(galleryData);
            const uniqueYears = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.date) {
                        const year = new Date(item.date).getFullYear();
                        return [year];
                    } else {
                        return [];
                    }
                }))
            );
            const uniqueYearRanges = uniqueYears.map(year => `${year}`);
            uniqueYearRanges.sort((a, b) => b - a);
            setYearRanges(uniqueYearRanges);
        };

        fetchData();
    }, []);

    useEffect(() => {
        let filteredData = data;
        
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                }
                return false;
            });
        } 

        // Sort the filteredData by month in descending order
        filteredData.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);
            return dateB - dateA;
        });

        setFilteredData(filteredData);
    }, [selectedYear, data]);
    const emptyArray = [
      {title:"News Title",description:"Stay Tunned For More Updates",day:"DD",month:"MM"}, 
     ];
     const handleModal = id => {
        navigate(`/newsInner?id=${id}`);
      };
     const homeMenu = [
        { label: "Latest Update", link: "/news" },
        { label: "Testimonials", link: "/testimonial" },
        { label: "School Calendar", link: "/calender" },
        { label: "CBSE Circulars", link: "/circular" },
        { label: "eMagazine", link: "/magazine" },
        { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
        { label: "Carpe Diem'22", link: "/carpediem" },
    ];
    return (
        <>
        <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner.jpg" />
            <Menu MenuItem={homeMenu} />            
            <div className="padding-blk inner-page">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <PageTitle pageTitle="CBSE Circulars" breadEnd="CBSE Circulars" breadMid="CBSE Circulars" />
                    </div>
                </div>
                    <div className="row ">
                         
                        <div className="col-xxl-12">
                            <div className="month-selection float-end">
                                <select
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="yearSelection">
                                    <option value={"All"}>All</option>
                                    {yearRanges.map((yr) => (
                                        <option key={yr} value={yr}>{yr}</option>
                                    ))}
                                </select>
                            </div>
                        </div> 
                         
                    </div>
                    <ul className="admission-list circular-list">
                        {filterData.length > 0 ? (
                            filterData.map((item, index) => {
                               
                                return (
                                        <li key={index}> <Link to={`https://webapi.entab.info/api/image/${item?.attachments}`} target="_blank" rel="noreferrer">{item.title}</Link>
                                        <span>{item.url && <Link to={item.url} target="_blank" rel="noreferrer">Click Here</Link>}</span>
                                        </li>  
                                    );
                                })
                              ) : (
                                emptyArray.map((item, index) => (
                                    <li> <a>Stay Tuned For More Updates</a></li> 
                                ))
                           )}
                    </ul>
                    </div>  
                    </div> 
                   <Footer/> 
        </>
    )
}

export default Circular;
